// extracted by mini-css-extract-plugin
export default {"constructionBodyContainer":"ConstructionBody_constructionBodyContainer__6jtoO","constructionBodyBlock":"ConstructionBody_constructionBodyBlock__vP-m0"};